import { Container } from '@src/components/Container/Container'

export const SlugPageContentSkeleton = () => {
  return (
    <div>
      <div className="h-8 w-full animate-pulse bg-bodi-cool-gray-200" />
      <div className="h-12 w-full animate-pulse bg-bodi-cool-gray-300" />
      <div className="h-[1080px] animate-pulse bg-bodi-cool-gray-200/50 lg:h-[630px]">
        <Container>
          <div className="flex size-full flex-col justify-between gap-12 pt-[48px] lg:flex-row lg:gap-80 lg:pt-[116px]">
            <div className="lg:h-full">
              <div className="mb-4 h-[200px] w-full animate-pulse rounded-xl bg-bodi-cool-gray-200 lg:h-[256px] lg:w-[450px]"></div>
              <div className="mb-4 h-[72px] w-full animate-pulse rounded-full bg-bodi-cool-gray-200 lg:h-[64px] lg:w-[250px]"></div>
              <div className="mb-4 hidden h-[64px] animate-pulse rounded-xl bg-bodi-cool-gray-200 lg:block lg:w-[450px]"></div>
            </div>
            <div className="mb-4 h-[250px] w-full animate-pulse rounded-xl bg-bodi-cool-gray-200 lg:h-auto lg:w-[450px] lg:flex-1"></div>
          </div>
        </Container>
      </div>
    </div>
  )
}
